import React from 'react';
import { Button, Message } from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import styled from 'styled-components';
import { Submit } from './Submit';

const Form = styled.form`
  display: grid;
  grid-row-gap: 0.75rem;
`;

interface Props {
  submit: Submit;
}

export default function NotificationUnsubscribeForm({ submit }: Props) {
  const { t } = useTranslation();

  return (
    <Form onSubmit={submit.handleSubmit} noValidate>
      {submit.errors && (
        <Message fullWidth type="error">
          {t('Unable to unsubscribe from notification')}
        </Message>
      )}
      <Button
        color="secondary"
        fullWidth
        isLoading={submit.isLoading}
        type="submit"
      >
        {t('Unsubscribe')}
      </Button>
    </Form>
  );
}
